import { REACT_APP_TESTING_MODE } from 'config';
import * as firebase from 'firebase-logic/firebase';

const getAccountInformationFunction = (companyId: string) => {
  const functionName = REACT_APP_TESTING_MODE(companyId)
    ? 'testGetAccountInformationPayPal'
    : 'getAccountInformationPayPal';

  return firebase.functionsEuropeWest3.httpsCallable(functionName);
};

export const PayPalAPI = {
  createPartnerReferral: async (companyId: string) => {
    const currentUser = firebase.auth.currentUser;
    if (!currentUser) {
      throw new Error('The current user is not authenticated');
    }

    const url = REACT_APP_TESTING_MODE(companyId)
      ? 'https://europe-west3-droov-group-1.cloudfunctions.net/testPayPalOnboarding/partner-referrals'
      : 'https://europe-west3-droov-group-1.cloudfunctions.net/payPalOnboarding/partner-referrals';
    const token = await currentUser.getIdToken(true);

    return fetch(url, {
      method: 'POST',
      mode: 'cors',
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
  },
  getAccountInformation: async (companyId: string) => {
    const getAccountInformationPayPal =
      getAccountInformationFunction(companyId);
    const result = await getAccountInformationPayPal();
    return result?.data;
  },
  completeOnboarding: async (
    companyId: string,
    trackingId: string,
    merchantId: string
  ) => {
    const completePayPalOnboarding = getAccountInformationFunction(companyId);
    const result = await completePayPalOnboarding({ trackingId, merchantId });
    return result?.data;
  },
};
